import { useState } from "react";
import "./styles/Auth.css"
import { useAuth } from "../hooks/Auth";
import { useNavigate } from "react-router";

function Login() {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const [errorMsg, setErrorMsg] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const {loginAction} = useAuth()

    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        setErrorMsg("");

        console.log(email, password)

        if (email && password){
            const credentials = JSON.stringify({email:email, password:password});
            const result = await loginAction(credentials);

            console.log(result);

            if (result?.error) {
                setErrorMsg(result.error);
                setIsLoading(false);
                return;
            }

            navigate("/gallery");
        }

        setIsLoading(false);
    }

    return(
        <div>
            <form onSubmit={handleSubmit} className="auth-form">

                <div className="auth-header">
                    <h1>Login</h1>
                </div>

                <text>Email</text>
                <input id="email" name="email" placeholder="Enter Email" onChange={(e) => {setEmail(e.target.value)}} disabled={isLoading}/>

                <text>Password</text>
                <input type="password" id="password" name="password" placeholder="Enter Password" onChange={(e) => {setPassword(e.target.value)}} disabled={isLoading}/>

                {errorMsg ? <text style={{color:"red"}}>{errorMsg}</text>:null}
                <button type="submit" disabled={isLoading}>login</button>

                <div className="auth-switch">
                    <text>No account?</text>
                    <a style={{color:"teal", margin:"auto", cursor:"pointer"}} onClick={() => navigate("/register")}>Register Here</a>
                </div>

            </form>
        </div>
    )

}

export default Login;
